import { graphql } from '~/__gql__';

export const queryValidateEmail = graphql(/* GraphQL */ `
  query ValidateEmail($input: String!) {
    validateEmail(input: $input)
  }
`);
